import { IProduct } from '@/entities/product/model/types';
import { IBranch, ICategory, IStocks } from '../_types';
import { request } from './http-client';
import { TParams } from './types';
import { IMultiLang } from '@/shared/types/locale';

interface IMikaCategory {
  categories: ICategory[];
  count: string;
}

export interface IMikaSearchObject {
  partner_shipper: null;
  products: {
    id: string;
    title: IMultiLang;
    out_price: number;
    image: string;
    description: IMultiLang;
    type: 'simple';
    active_in_menu: true;
    modifiers: null;
    categories: ICategory[];
    weight: number;
    measurement: string;
    has_modifier: false;
  }[];
  partner_shipper_id: string;
  id: string;
  name: string;
  description: string;
  logo: string;
  shipper_id: string;
  branch: {
    id: string;
    shipper_id: string;
    name: string;
    images: string[];
    phones: string[];
    is_active: boolean;
    address: string;
    location: {
      long: number;
      lat: number;
    };
    created_at: string;
    updated_at: string;
    destination: string;
    work_hour_start: string;
    work_hour_end: string;
    jowi_id: null;
    iiko_id: null;
    iiko_terminal_id: null;
    fare_id: string;
    tg_chat_id: string;
    geozone_id: null;
    geozone: null;
    orders_limit: string;
    radius_without_delivery_price: number;
    real_time_orders_amount: number;
    fare: null;
    menu_id: null;
    menu_title: null;
    crm: string;
    iiko_hall_terminal_id: string;
    slug: string;
    phone: string;
    description: null;
    seats_count: number;
    virtual_tour: string;
    has_parking: false;
    seo_text: null;
    future_delivery_order_time: string;
    future_self_pickup_order_time: string;
    open_time: string;
    close_time: string;
    week_day: string;
    delivery_time: 60;
    reserve_table_id: string;
    is_work: false;
    is_work_24_7: false;
    order_type_ids: string[];
    order_no: string;
    is_crm_working: true;
    order_types: [];
    shipper_name: string;
    has_kindergarden: false;
  };
  source_id: string;
}

const mikaService = {
  getBranchList: (params: {
    long?: number;
    lat?: number;
    page: number;
    limit: number;
    is_open: boolean;
    search: string;
    shipper_tag_ids?: string;
  }) =>
    request.get<{
      branches: IBranch[];
      count: string;
    }>(`/v2/mika/branches`, { params }),
  refresh: (data: { shipper_id: string; token: string }) =>
    request.post<{
      access_token: string;
      created_at: string;
      id: string;
      is_blocked: boolean;
      name: string;
      phone: string;
      refresh_token: string;
    }>(`/v2/mika/refresh`, data),
  getCategoryList: (params: any, shipper_id?: string, platform_id?: string) =>
    request.get<IMikaCategory>(`/v2/mika/main-page/category`, {
      params,
      headers: {
        Authorization: '',
        ...(shipper_id ? { Shipper: shipper_id } : {}),
        ...(platform_id ? { Platform: platform_id } : {}),
      },
    }),
  promo: (params: any, shipper_id?: string, platform_id?: string) =>
    request.get<{ promos: IStocks[]; count: string }>(`/v2/mika/promo`, {
      params,
      headers: { Shipper: shipper_id, Platform: platform_id },
    }),
  search: (
    params: {
      search?: string;
      lat: number;
      long: number;
      page: number;
      limit: number;
      product_types: string;
    },
    shipper_id?: string,
    platform_id?: string,
  ) =>
    request.get<{
      objects: IMikaSearchObject[];
      count: '1';
    }>('/v3/mika/search', {
      params,
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
      },
    }),
  searchByRestaurant: (
    params: TParams,
    shipper_id?: string,
    platform_id?: string,
  ) =>
    request.get<{
      description: string;
      shipper_id: string;
      logo: string;
      name: string;
      products: IProduct[];
      count: number;
    }>('/v2/mika/restaurant-page', {
      params,
      headers: {
        Shipper: shipper_id,
        Platform: platform_id,
      },
    }),
};

export default mikaService;
